export default __webpack_public_path__ + "static/media/Calibri-Italic.7f533724.ttf";